import React from "react";
import ReactECharts from "echarts-for-react";
import { Spin, Empty } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface OverdueTasksBarChartProps {
  loading: boolean;
  chartData: {
    buckets: string[]; // ["1–7", "8–14", ...]
    taskCounts: number[]; // [10, 8, 5, 3, 2]
  } | null;
}

const OverdueTasksBarChart: React.FC<OverdueTasksBarChartProps> = ({
  loading,
  chartData,
}) => {
  console.log("overdue chart data", chartData);
  const getChartOptions = () => {
    if (!chartData) return {};

    return {
      animationDuration: 800,
      tooltip: {
        trigger: "axis",
        formatter: (params: any) => {
          const data = params[0];
          return `${data.name} days: ${data.value} tasks`;
        },
      },
      grid: {
        left: 20,
        right: 30,
        bottom: 35,
        top: 15,
        containLabel: true,
      },
      xAxis: {
        type: "value",
        name: "Tasks",
        nameLocation: "middle",
        nameGap: 22,
        axisLabel: {
          fontSize: 11,
        },
      },
      yAxis: {
        type: "category",
        data: chartData.buckets,
        axisTick: { show: false },
        axisLabel: {
          fontSize: 11,
          formatter: (val: string) => `${val} days`,
        },
      },
      series: [
        {
          type: "bar",
          data: chartData.taskCounts,
          itemStyle: {
            color: "#ef4a13",
          },
          barWidth: 16,
          label: {
            show: true,
            position: "right",
            fontSize: 10,
            color: "#666",
          },
        },
      ],
    };
  };

  if (loading) {
    return (
      <div
        style={{
          height: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      </div>
    );
  }

  if (
    !chartData ||
    chartData.buckets.length === 0 ||
    chartData.taskCounts.every((count: number) => count === 0)
  ) {
    return (
      <div
        style={{
          height: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Empty description="No data found" />
      </div>
    );
  }

  return (
    <ReactECharts
      option={getChartOptions()}
      style={{ height: 260, width: "100%" }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default OverdueTasksBarChart;
